import * as React from 'react';
import { Box, Button, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import dashboard from "../Assets/dash/dashboard.png";
import delivery from "../Assets/dash/delivery.svg";
import order from "../Assets/dash/order.svg";
import product from "../Assets/dash/product.svg";
import user from "../Assets/dash/user.svg";
import { useDispatch, useSelector } from "react-redux";
import { updatepageName } from "../Redux/page";
import { Menu as PrimeMenu } from 'primereact/menu';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useNavigate } from 'react-router-dom';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { GROWTH_FEATURE_CARDS } from './growth_hub/growth_features_hub';

export function Sidebar() {
  const dispatch = useDispatch();
  const editMenu = React.useRef(null);
  const settingsMenu = React.useRef(null);
  const businessOpsMenu = React.useRef(null);
  const pagename = useSelector(state => state.page.pageName);
  const inventory = useSelector(state => state.inventory.inventory);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const subMenuOpen = Boolean(subMenuAnchorEl);
  const navigate = useNavigate()
  const user_role = localStorage.getItem('role');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleSubMenuOpen = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const growthPageNames = GROWTH_FEATURE_CARDS.map((c) => c.pageName).concat([
    'growth_hub',
  ]);
  const isGrowthActive = growthPageNames.includes(pagename);

  // Role-based menu items
  const getEditItems = () => {
    const allItems = [
      {
        label: 'Product Details',
        command: () => {
          navigate("/home/product_details")
          dispatch(updatepageName("product_details"))
        }
      },
      {
        label: 'Inventory',
        command: () => {
          navigate("/home/inventory")
          dispatch(updatepageName("inventory"))
        }
      },

      {
        label: 'Campaign',
        command: () => {
          navigate("/home/campaign")
          dispatch(updatepageName("campaign"))
        }
      },
      {
        label: 'Campaign push notification',
        command: () => {
          navigate("/home/Campaign_push_notification")
          dispatch(updatepageName("Campaign_push_notofication"))
        }
      },
      {
        label: 'Product Banner',
        command: () => {
          navigate("/home/product_banner")
        }
      },
      {
        label: 'Home Banner',
        command: () => {
          navigate("/home/home_banner")
        }
      }
    ];

    // Filter based on role
    switch (user_role) {
      case 'super_admin':
        return allItems; // Super Admin sees everything
      case 'admin':
        return allItems; // Admin sees everything
      case 'supervisor':
        const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
        const selectedFranchiseId = localStorage.getItem('selected_franchise_id');
        const isFoodFixSupervisor = selectedFranchiseId && parseInt(selectedFranchiseId) === 2;
        
        const hasFoodFixHub = inventory && inventory.some(hub => 
          assignedHubs.includes(hub.value) && hub.franchise_id === 2
        );
        
        const canAccessCampaign = isFoodFixSupervisor || hasFoodFixHub;
        
        console.log('Sidebar - Supervisor Debug:', {
          user_role,
          assignedHubs,
          selectedFranchiseId,
          isFoodFixSupervisor,
          hasFoodFixHub,
          canAccessCampaign,
          inventory: inventory?.map(hub => ({ id: hub.value, name: hub.name, franchise_id: hub.franchise_id }))
        });
        
        if (canAccessCampaign) {
          return allItems;
        } else {
          return allItems.filter(item => 
            item.label !== 'Campaign push notification'
          );
        }
      case 'customer_engagement_admin':
        return allItems.filter(item => 
          ['Product Details', 'Inventory', 'Campaign', 'Campaign push notification', 'Product Banner'].includes(item.label)
        ); 
      default:
        return [];
    }
  };

  const getSettingMenu = () => {
    const allItems = [
      {
        label: 'Category Settings',
        command: () => {
          navigate("/home/category")
          dispatch(updatepageName("category"))
        }
      },
      {
        label: 'Sub Category Settings',
        command: () => {
          navigate("/home/sub_category")
          dispatch(updatepageName("sub_category"))
        }
      },
    {
      label: 'Profile Settings',
      command: () => {
        navigate("/home/profile_settings")
        dispatch(updatepageName("profile_settings"))
      }
    },
      {
        label: 'General',
        command: () => {
          navigate("/home/general")
          dispatch(updatepageName("general"))
        }
      },
      {
        label: 'App Version Control',
        command: () => {
          navigate("/home/app_version_control")
          dispatch(updatepageName("app_version_control"))
        }
      },
      {
        label: 'Launch Screen',
        command: () => {
          navigate("/home/launch_screen")
          dispatch(updatepageName("launch_screen"))
        }
      },
      {
        // Privacy, Terms and anything added later. Edited here, stored in blob,
        // and read by the app without a release.
        label: 'Content',
        command: () => {
          navigate("/home/content_cms")
          dispatch(updatepageName("content_cms"))
        }
      },
      {
        label: 'Landing Page Ads',
        command: () => {
          navigate("/home/landing_page_ads")
          dispatch(updatepageName("landing_page_ads"))
        }
      },
      {
        label: "Add Instruction",
        command: () => {
          navigate('/home/addinstruction')
          dispatch(updatepageName("addinstruction"))
        }
      }
    ];

    // Filter based on role
    switch (user_role) {
      case 'super_admin':
        return allItems; // Super Admin sees everything
      case 'admin':
        return allItems; // Admin sees everything
      case 'supervisor':
        return allItems.filter(item => 
          item.label !== 'App Version Control' // Hub Supervisor cannot control app version settings
        );
      case 'customer_engagement_admin':
        return []; // Customer Engagement Admin doesn't see settings
      default:
        return [];
    }
  };

  const getBusinessOpsMenu = () => {
    const allItems = [
      {
        label: 'BO Settings',
        command: () => {
          navigate("/home/bo_settings")
          dispatch(updatepageName("bo_settings"))
        }
      },
      {
        label: 'BO Category Settings',
        command: () => {
          navigate("/home/bo_category_settings")
          dispatch(updatepageName("bo_category_settings"))
        }
      },
      {
        label: 'Business Operation History',
        command: () => {
          navigate("/home/business_operation_history")
          dispatch(updatepageName("business_operation_history"))
        }
      }
    ];

    // Filter based on role
    switch (user_role) {
      case 'super_admin':
        return allItems;
      case 'accountant':
        return allItems;
      default:
        return [];
    }
  };

  const editItems = getEditItems();
  const settingMenu = getSettingMenu();
  const businessOpsMenuItems = getBusinessOpsMenu();

  // Check if user can access settings
  const canAccessSettings = ['super_admin', 'admin', 'supervisor'].includes(user_role);
  const canAccessBusinessOps = ['super_admin', 'accountant'].includes(user_role);
  const canAccessGrowth = ['super_admin', 'admin', 'supervisor'].includes(user_role);

  const logout = () => {
    localStorage.clear()
    localStorage.removeItem('hub');
    navigate("/")
  }

    // Cashiers do not need the sidebar
    if (user_role === 'cashier') {
      return null;
    }

    
  return (
    <Box sx={{ display: 'block', position: { xs: "absolute", md: "sticky" }, top: { xs: 16, md: "0" }, right: { xs: 20, md: "initial" } }}>
      {/* Desktop Sidebar */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: "84px",
          /*
           * As tall as the window, not 850px.
           *
           * A fixed pixel height fits exactly the items that existed the day it
           * was typed. Adding Reports pushed Settings past 850 and it was cut
           * off at the bottom -- and on any laptop shorter than 890px the last
           * item was already unreachable before that. The height now follows
           * the viewport, and the list scrolls inside if it ever outgrows even
           * that.
           */
          height: "calc(100vh - 48px)",
          overflowY: "auto",
          // No scrollbar down an 84px rail: it would eat a fifth of the width
          // and sit on top of the labels.
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          padding: "24px 8px",
          backgroundColor: "background.light",
          marginLeft: "20px",
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 25px 0px #0000001A",
          flexDirection: "column",
          // The items must keep their size when the rail is short -- without
          // this flex would compress them to fit and the icons would squash.
          flexShrink: 0,
          "& > *": { flexShrink: 0 },
          gap: "18px",
          position: "sticky",
          top: "24px"
        }}
      >
        <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => (navigate("/home/dashboard"), dispatch(updatepageName("dashboard")))}>
          <Box component="img" src={dashboard} sx={{ color: "green" }} />
          <Typography sx={{ fontSize: "9px", color: pagename === "dashboard" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Dashboard
          </Typography>
        </Button>

        <Box className="productManagement" sx={{ position: "relative" }}>
          <PrimeMenu model={editItems} popup ref={editMenu} style={{ marginLeft: "78px", marginTop: "-70px", maxWidth: "300px", width: "100%" }} className="custom-menu" />
          <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={(event) => editMenu.current.toggle(event)}>
            <Box component="img" src={product} />
            <Typography sx={{ fontSize: "9px", color: pagename === "product_details" || pagename === "inventory" || pagename === "inventoryBatchList" || pagename === "BatchHistory" || pagename === "campaign" || pagename === "Campaign_push_notification" || pagename ==="product_banner"? "primary.main" : "text.secondary", textAlign: "center" }}>
              Product Management
            </Typography>
          </Button>
        </Box>

        <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => (navigate("/home/order_management"), dispatch(updatepageName("order_management")))}>
          <Box component="img" src={order} />
          <Typography sx={{ fontSize: "9px", color: pagename === "order_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Order Management
          </Typography>
        </Button>

        {/*
          Reports, for super admin only.

          These read every customer's mobile number and order history across
          every hub. A hub admin has no reason to hold that view, so the entry
          is not rendered for them at all rather than shown and refused -- the
          endpoint enforces the same rule, so hiding it here is convenience,
          not the security boundary.

          Stage moved this out of the Product Management popup and into the rail,
          which is kept: in the popup it was effectively invisible. What is NOT
          taken from stage is its removal of the role check. That check is a
          deliberate decision on this side and it guards customer data, so a
          merge must not quietly drop it.
        */}
        {user_role === 'super_admin' && (
          <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => (navigate("/home/reports"), dispatch(updatepageName("reports")))}>
            <Box component="img" src={user} />
            <Typography sx={{ fontSize: "9px", color: pagename === "reports" ? "primary.main" : "text.secondary", textAlign: "center" }}>
              Reports
            </Typography>
          </Button>
        )}

        <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => (navigate("/home/delivery_management"), dispatch(updatepageName("delivery_management")))}>
          <Box component="img" src={delivery} />
          <Typography sx={{ fontSize: "9px", color: pagename === "delivery_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Delivery Management
          </Typography>
        </Button>

        <Button disabled={true} sx={{ display: "flex", flexDirection: "column", gap: "2px", opacity: .5 }} onClick={() => (navigate("/home/user_management"), dispatch(updatepageName("user_management")))}>
          <Box component="img" src={user} />
          <Typography sx={{ fontSize: "9px", color: pagename === "user_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            User Management
          </Typography>
        </Button>

        <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => (navigate("/home/offer_management"), dispatch(updatepageName("offer_management")))}>
          <Box component="img" src={order} />
          <Typography sx={{ fontSize: "9px", color: pagename === "offer_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Offer Management
          </Typography>
        </Button>

        {canAccessGrowth && (
          <Button
            sx={{ display: "flex", flexDirection: "column", gap: "2px" }}
            onClick={() => {
              navigate("/home/growth_hub");
              dispatch(updatepageName("growth_hub"));
            }}
          >
            <AutoAwesomeOutlinedIcon
              sx={{ color: isGrowthActive ? "primary.main" : "secondary.main", fontSize: 22 }}
            />
            <Typography
              sx={{
                fontSize: "9px",
                color: isGrowthActive ? "primary.main" : "text.secondary",
                textAlign: "center",
                lineHeight: 1.15,
              }}
            >
              Growth Features
            </Typography>
          </Button>
        )}

        {canAccessBusinessOps && (
          <Box className="businessOpsManagement" sx={{ position: "relative" }}>
            <PrimeMenu model={businessOpsMenuItems} popup ref={businessOpsMenu} style={{ marginLeft: "78px", marginTop: "-70px", maxWidth: "300px", width: "100%" }} className="custom-menu" />
            <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={(event) => businessOpsMenu.current.toggle(event)}>
              <Box component="img" src={order} />
              <Typography sx={{ fontSize: "9px", color: pagename === "bo_settings" || pagename === "bo_category_settings" || pagename === "business_operation_history" ? "primary.main" : "text.secondary", textAlign: "center" }}>
                Business Operations Management
              </Typography>
            </Button>
          </Box>
        )}

        {canAccessSettings && (
          <Box className="productManagement" sx={{ position: "relative" }}>
            <PrimeMenu model={settingMenu} popup ref={settingsMenu} style={{ marginLeft: "78px", marginTop: "-70px", width: "200px" }} className="custom-menu" />
            <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={(event) => settingsMenu.current.toggle(event)}>
              <SettingsOutlinedIcon sx={{ color: "secondary.main" }} />
              <Typography sx={{ fontSize: "9px", color: pagename === "category" || pagename === "general" || pagename === "profile_settings" ? "primary.main" : "text.secondary", textAlign: "center" }}>
                Settings
              </Typography>
            </Button>
          </Box>
        )}

        <Button sx={{ display: "flex", flexDirection: "column", gap: "2px" }} onClick={() => logout()}>
          <Box component="img" src={user} />
          <Typography sx={{ fontSize: "9px", color: pagename === "user_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Logout
          </Typography>
        </Button>
      </Box>

      {/* Mobile Hamburger Menu */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <IconButton
          id="compact-menu-button"
          aria-controls={menuOpen ? 'compact-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpen ? 'true' : undefined}
          onClick={handleClick}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>

        <Menu
          id="compact-menu"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'compact-menu-button',
          }}
        >
          <Box >
            {/* <Typography variant="h6" sx={{ mb: 1 }}>Menu</Typography>onClick={() => navigate("/home/dashboard")) */}
            <MenuItem onClick={() => { navigate("/home/dashboard"); dispatch(updatepageName("dashboard")); handleClose(); }}>Dashboard</MenuItem>
            {/* Product Management with Submenu */}
            <MenuItem
              onClick={handleSubMenuOpen}
              aria-haspopup="true"
              aria-controls={subMenuOpen ? 'product-submenu' : undefined}
            >
              Product Management
            </MenuItem>

            {/* Submenu for Product Management */}
            <Menu
              id="product-submenu"
              anchorEl={subMenuAnchorEl}
              open={subMenuOpen}
              onClose={handleSubMenuClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {user_role === 'customer_engagement_admin' ? (
                // Customer Engagement Admin sees Product Details, Campaign, Campaign Push Notification, and Product Banner
                <>
                  <MenuItem onClick={() => { navigate("/home/product_details"); dispatch(updatepageName("product_details")); handleClose(); }}>Product Details</MenuItem>
                  <MenuItem onClick={() => { navigate("/home/campaign"); dispatch(updatepageName("campaign")); handleClose(); }}>Campaign</MenuItem>
                  <MenuItem onClick={() => { navigate("/home/Campaign_push_notification"); dispatch(updatepageName("Campaign_push_notofication")); handleClose(); }}>Campaign Push Notification</MenuItem>
                  <MenuItem onClick={() => { navigate("/home/product_banner"); dispatch(updatepageName("product_banner")); handleClose(); }}>Product Banner</MenuItem>
                </>
              ) : (
                // Other roles see all product management options
                <>
                  <MenuItem onClick={() => { navigate("/home/product_details"); dispatch(updatepageName("product_details")); handleClose(); }}>Product Details</MenuItem>
                  <MenuItem onClick={() => { navigate("/home/inventory"); dispatch(updatepageName("inventory")); handleClose(); }}>Inventory</MenuItem>
                  <MenuItem onClick={() => { navigate("/home/campaign"); dispatch(updatepageName("campaign")); handleClose(); }}>Campaign</MenuItem>
                  {user_role !== 'supervisor' && (
                    <MenuItem onClick={() => { navigate("/home/Campaign_push_notification"); dispatch(updatepageName("Campaign_push_notofication")); handleClose(); }}>Campaign Push Notification</MenuItem>
                  )}
                </>
              )}
            </Menu>
            <MenuItem onClick={() => { navigate("/home/order_management"); dispatch(updatepageName("order_management")); handleClose(); }}>Order Management</MenuItem>
            <MenuItem onClick={() => { navigate("/home/delivery_management"); dispatch(updatepageName("delivery_management")); handleClose(); }}>Delivery Management</MenuItem>
            <MenuItem disabled={true} onClick={() => { navigate("/home/user_management"); dispatch(updatepageName("user_management")); handleClose(); }}>User Management</MenuItem>
            <MenuItem onClick={() => { navigate("/home/offer_management"); dispatch(updatepageName("offer_management")); handleClose(); }}>Offer Management</MenuItem>
            {canAccessGrowth && (
              <MenuItem
                onClick={() => {
                  navigate('/home/growth_hub');
                  dispatch(updatepageName('growth_hub'));
                  handleClose();
                }}
              >
                Growth Features
              </MenuItem>
            )}
            {canAccessBusinessOps && (
              <>
                <MenuItem onClick={() => { navigate("/home/bo_settings"); dispatch(updatepageName("bo_settings")); handleClose(); }}>BO Settings</MenuItem>
                <MenuItem onClick={() => { navigate("/home/bo_category_settings"); dispatch(updatepageName("bo_category_settings")); handleClose(); }}>BO Category Settings</MenuItem>
                <MenuItem onClick={() => { navigate("/home/business_operation_history"); dispatch(updatepageName("business_operation_history")); handleClose(); }}>Business Operation History</MenuItem>
              </>
            )}
            {canAccessSettings && (
              <>
                <MenuItem onClick={() => { navigate("/home/category"); dispatch(updatepageName("category")); handleClose(); }}>Category Settings</MenuItem>
                <MenuItem onClick={() => { navigate("/home/sub_category"); dispatch(updatepageName("sub_category")); handleClose(); }}>Sub Category Settings</MenuItem>
                <MenuItem onClick={() => { navigate("/home/general"); dispatch(updatepageName("general")); handleClose(); }}>General Settings</MenuItem>
                {user_role !== 'supervisor' && (
                  <MenuItem onClick={() => { navigate("/home/app_version_control"); dispatch(updatepageName("app_version_control")); handleClose(); }}>App Version Control</MenuItem>
                )}
                <MenuItem onClick={() => { navigate("/home/addinstruction"); dispatch(updatepageName("addinstruction")); handleClose(); }}>Instruction Management</MenuItem>
              </>
            )}
            <MenuItem onClick={() => logout()}>Logout</MenuItem>
          </Box>
        </Menu>
      </Box>
    </Box>
  );
}
